<!-- 鼠标右击进行操作 -->
<template>
    <div class="RightClickOperation">
      <!-- 1：ctrl+c右击 -->
      <div class="MouseRightClick CtrlRightClick" data-id="MouseRightClick" v-if="OperationStyle.type" :style="OperationStyle.style">
        <div v-if="OperationStyle.event">
          <div class="operation" data-id="MouseRightClick" @click="CopyandMoveEvent('Copy', 1)">
            {{ $t('lang.pasteBefore') }}
          </div>
          <div class="operation" data-id="MouseRightClick" @click="CopyandMoveEvent('Copy', 2)">
            {{ $t('lang.pasteAfter') }}
          </div>
        </div>
        <div v-else>
          <div class="operation" data-id="MouseRightClick" @click="CopyandMoveEvent('Copy')">
            {{ $t('lang.pasteHere') }}
          </div>
        </div>
      </div>
      <!-- 0：选中事件右击 -->
      <div class="MouseRightClick" data-id="MouseRightClick" v-else :style="OperationStyle.style">
        <div class="operation" data-id="MouseRightClick" @click="DeleteMoreEvent">
          {{ $t('lang.delete') }}
        </div>
        <div class="operation" data-id="MouseRightClick" @click="CopyandMoveEvent('Move')">
          {{ $t('lang.Move') }}
        </div>
        <div class="operation" data-id="MouseRightClick" @click="CopyandMoveEvent('Duplicate')">
          {{ $t('lang.duplicate') }}
        </div>
      </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
export default {
  props: {
    OperationStyle: {
      type: Object,
      default: () => ({
        type: 0, // 0：选中事件右击 1：ctrl+c右击
        Switch: false,
        style: {},
        event: false, // 是否再事件上右击
        startTime: '',
        dataId: ''
      })
    },
    PitchEventList: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      // 是否为FollowOn事件
      multipleModelType: 0
    }
  },
  computed: {
    ...mapState({
      // ctrl+c 复制的事件
      CtrlCopyEvent: (state) => state.playout.CtrlCopyEvent,
      CloneDisabled: (state) => state.playout.CloneDisabled
    })
  },
  created () {

  },
  mounted () {
    console.log(this.OperationStyle, 'jjjjjj')
    this.multiOperationParam()
  },
  methods: {
    // 删除
    DeleteMoreEvent () {
      if (this.CloneDisabled.Event || this.CloneDisabled.disableButton) return
      this.$emit('DeleteMoreEvent')
    },
    // 复制移动
    CopyandMoveEvent (type, event) {
      if (this.CloneDisabled.Event || this.CloneDisabled.disableButton) return
      // 1：ctrl+c右击
      if (this.OperationStyle.type) {
        this.checkExistEventByTime(type, event)

      // 0：选中事件右击
      } else {
        this.$emit('CopyandMoveEvent', false, type)
      }
    },
    // 检查FollowOn前是否有事件
    checkExistEventByTime (type, event) {
      console.log(this.OperationStyle, 'oooooooooooooooo')
      let TimeAndId
      const parameter = {
        programId: this.$BehaviorSyns.getProgramId(),
        operationType: 0
      }
      // 事件
      if (this.OperationStyle.event) {
        parameter.operationType = 1
        parameter.eventId = this.OperationStyle.dataId
        TimeAndId = this.OperationStyle.dataId
      // 时间
      } else {
        parameter.time = this.OperationStyle.startTime
        TimeAndId = this.OperationStyle.startTime
      }
      if (this.multipleModelType) {
        this.axios.post(Outil.getUrl('/event/checkExistEventByTime'), parameter)
          .then((res) => {
            if (res.data.errorCode == '0x0') {
              if (!res.data.result) {
                this.$confirm(this.$t('lang.modeChange1'), '', {
                  confirmButtonText: this.$t('lang.Confirm'),
                  cancelButtonText: this.$t('lang.close'),
                  dangerouslyUseHTMLString: true
                }).then(() => {
                  this.$emit('CopyandMoveEvent', true, type, {
                    FollowOn: true,
                    TimeAndId,
                    event
                  })
                }).catch(() => {})
              } else {
                this.$emit('CopyandMoveEvent', true, type, {
                  FollowOn: false,
                  TimeAndId,
                  event
                })
              }
            } else {
              const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.info(errorInfo)
            }
          }).catch((res) => {})
      } else {
        this.$emit('CopyandMoveEvent', true, type, {
          FollowOn: false,
          TimeAndId,
          event
        })
      }
    },
    // 是否是FollowOn
    multiOperationParam () {
      let OperationEventList = []
      if (this.OperationStyle.type) {
        OperationEventList = this.CtrlCopyEvent
      } else {
        OperationEventList = this.PitchEventList
      }
      if (OperationEventList.length > 0) {
        const event = OperationEventList[0]
        if (event.multipleModelType) {
          this.multipleModelType = true
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
.RightClickOperation {
  .MouseRightClick {
    position: fixed;
    background: #252525;
    z-index: 2000;
    padding: 12px 12px 7px;
    box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    cursor: pointer;
    .operation {
      width: 70px;
      height: 25px;
      line-height: 25px;
      text-align: left;
      margin-bottom: 5px;
    }
  }
  .CtrlRightClick {
    .operation {
      width: 90px;
    }
  }
}
</style>
